import React from "react";

function MailIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M2.167 19.688h20v-15h-20v15z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.167 4.688l10 7.5 10-7.5"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.166 4.688h-10v7.5"
      ></path>
    </svg>
  );
}

export default MailIcon;
